import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from 'containers/App';
import storeWithPersistor from 'store';
import * as serviceWorkerRegistration from 'serviceWorkerRegistration';
import { registerServiceWorker } from 'serviceWorkerRegistration';
import reportWebVitals from 'reportWebVitals';
import './assets/styles/style.scss';

ReactDOM.render(
  <Provider store={storeWithPersistor.store}>
    <PersistGate loading={null} persistor={storeWithPersistor.persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
